export default null;

export function PasswordGenerator({ length = 8 }) {
    // minium 8 characters and maximum 32 characters
    // Minimum 1 Latter, 1 number and 1 special character, 1 uppercase letter
    // Return string
    let password = '';
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+';
    for (let i = 0; i < length; i += 1) {
        password += charset.charAt(Math.floor(Math.random() * charset.length));
    }

    return password;
}
